import { get } from 'utils/http';
import { BASE_URL } from 'constants/env';

export const GUIDE_TYPES_SWR_KEY = '/cms/catalog/guide-types';

/**
 * Gets the possible guide types from the database
 *
 * @returns {Promise<GuideType[]>}
 */
export const getGuideTypes = () => {
    return get(`${BASE_URL}/cms/catalog/guide-types`).then((result = {}) => {
        return result.objects;
    });
};
